import React, { memo } from "react";
import { useRouter } from "next/router";
import { FeatureCardContainer, FeatureIcon, FeatureText } from "../../styles/featureCard";
import { DLS_TEXT_VARIANTS } from "../../constants/dls";
import { logYourReferralsClick, logProfileClick, logEarningsClick, logCityWiseBonusClick } from "./analytics";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

interface IFeatureCard {
    text: string;
    iconSrc: string;
    path: string;
}

const FeatureCard = ({ text, iconSrc, path }: IFeatureCard) => {
    const router = useRouter();

    const onClick = () => {
        if (text === "Your Referrals") {
            logYourReferralsClick();
        } else if (text === "Profile") {
            logProfileClick();
        } else if (text === "Earnings") {
            logEarningsClick();
        } else if (text === "City wise bonus") {
            logCityWiseBonusClick();
        }
        router.push(path);
    };

    return (
        <FeatureCardContainer onClick={onClick}>
            <Image src={iconSrc} width="24px" height="24px" />
            <FeatureText variant={DLS_TEXT_VARIANTS.BODY_B2_BOLD}>{text}</FeatureText>
        </FeatureCardContainer>
    );
};

export default memo(FeatureCard);
